import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvFeedback, AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { getEntity, updateEntity, createEntity, reset } from './admin-audit-history.reducer';
import { IAdminAuditHistory } from 'app/shared/model/admin-audit-history.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';

export interface IAdminAuditHistoryUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const AdminAuditHistoryUpdate = (props: IAdminAuditHistoryUpdateProps) => {
  const [isNew, setIsNew] = useState(!props.match.params || !props.match.params.id);

  const { adminAuditHistoryEntity, loading, updating } = props;

  const handleClose = () => {
    props.history.push('/admin-audit-history');
  };

  useEffect(() => {
    if (isNew) {
      props.reset();
    } else {
      props.getEntity(props.match.params.id);
    }
  }, []);

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const saveEntity = (event, errors, values) => {
    if (errors.length === 0) {
      const entity = {
        ...adminAuditHistoryEntity,
        ...values,
      };

      if (isNew) {
        props.createEntity(entity);
      } else {
        props.updateEntity(entity);
      }
    }
  };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="satshrutApp.adminAuditHistory.home.createOrEditLabel">Create or edit a AdminAuditHistory</h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <AvForm model={isNew ? {} : adminAuditHistoryEntity} onSubmit={saveEntity}>
              {!isNew ? (
                <AvGroup>
                  <Label for="admin-audit-history-id">ID</Label>
                  <AvInput id="admin-audit-history-id" type="text" className="form-control" name="id" required readOnly />
                </AvGroup>
              ) : null}
              <AvGroup>
                <Label id="newJsonLabel" for="admin-audit-history-newJson">
                  New Json
                </Label>
                <AvField id="admin-audit-history-newJson" type="text" name="newJson" />
              </AvGroup>
              <AvGroup>
                <Label id="oldJsonLabel" for="admin-audit-history-oldJson">
                  Old Json
                </Label>
                <AvField id="admin-audit-history-oldJson" type="text" name="oldJson" />
              </AvGroup>
              <AvGroup>
                <Label id="typeLabel" for="admin-audit-history-type">
                  Type
                </Label>
                <AvField id="admin-audit-history-type" type="text" name="type" />
              </AvGroup>
              <AvGroup>
                <Label id="subscriptionHistoryIdLabel" for="admin-audit-history-subscriptionHistoryId">
                  Subscription History Id
                </Label>
                <AvField
                  id="admin-audit-history-subscriptionHistoryId"
                  type="string"
                  className="form-control"
                  name="subscriptionHistoryId"
                />
              </AvGroup>
              <AvGroup>
                <Label id="subscriptionPlanIdLabel" for="admin-audit-history-subscriptionPlanId">
                  Subscription Plan Id
                </Label>
                <AvField id="admin-audit-history-subscriptionPlanId" type="string" className="form-control" name="subscriptionPlanId" />
              </AvGroup>
              <AvGroup>
                <Label id="updatedByLabel" for="admin-audit-history-updatedBy">
                  Updated By
                </Label>
                <AvField id="admin-audit-history-updatedBy" type="string" className="form-control" name="updatedBy" />
              </AvGroup>
              <AvGroup>
                <Label id="updatedOnLabel" for="admin-audit-history-updatedOn">
                  Updated On
                </Label>
                <AvField id="admin-audit-history-updatedOn" type="date" className="form-control" name="updatedOn" />
              </AvGroup>
              <Button tag={Link} id="cancel-save" to="/admin-audit-history" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">Back</span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp; Save
              </Button>
            </AvForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (storeState: IRootState) => ({
  adminAuditHistoryEntity: storeState.adminAuditHistory.entity,
  loading: storeState.adminAuditHistory.loading,
  updating: storeState.adminAuditHistory.updating,
  updateSuccess: storeState.adminAuditHistory.updateSuccess,
});

const mapDispatchToProps = {
  getEntity,
  updateEntity,
  createEntity,
  reset,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(AdminAuditHistoryUpdate);
